export default __webpack_public_path__ + "static/media/desktop.4e2c11ed.jpg";